module.exports = __webpack_public_path__ + "img/icon_wy15.3579024e.png";